import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrivacy = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "outline-flat",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M33,62.5c-14.06,0-25.5-11.44-25.5-25.5V7.83L33,1.45l25.5,6.38v29.17c0,14.06-11.44,25.5-25.5,25.5ZM10.5,10.17v26.83c0,12.41,10.09,22.5,22.5,22.5s22.5-10.09,22.5-22.5V10.17l-22.5-5.62-22.5,5.62Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M33,40.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5ZM33,37.5c-.28,0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M44.5,46.5h-23v-17h23v17ZM24.5,43.5h17v-11h-17v11Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M40.5,32.5h-3v-9.5c0-2.48-2.02-4.5-4.5-4.5s-4.5,2.02-4.5,4.5v9.5h-3v-9.5c0-4.14,3.36-7.5,7.5-7.5s7.5,3.36,7.5,7.5v9.5Z"
		})
	]
});
export default SvgPrivacy;
